import { Grid, IconButton, Tooltip } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiInput from "components/SuiInput";
import Alert from "custom/Alert";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import DataTable from "custom/Tables/DataTable";
import MessageTypes from "enums/message-types";
import { FunnelSimple, Pencil } from "phosphor-react";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { removeMessage } from "redux/actions/message";
import { getSubOrganizationListByOrganizationId } from "redux/actions/pages/sub-organization";
import { ALL_CLASSES, startAllClassesScreen } from "redux/actions/pages/class";

import { startAllOrganizationsScreen } from "redux/actions/pages/organization";

import Swal from "sweetalert2";
import SuiTypography from "components/SuiTypography";
import CustomFormField from "components/CustomFormField";
import { Formik } from "formik";

const ClassList = ({
  message,
  localizations,
  allSubOrganizations,
  startScreen,
  removeErrorMsg,
  language,
  allOrganizations,
  listByOrganizationId,
  getAllOrganizations,
  classList,
}) => {
  const [classFilter, setClassFilter] = useState("");
  const history = useHistory();

  useEffect(() => {
    startScreen();
    if (!allOrganizations || allOrganizations.length === 0) {
      getAllOrganizations();
    }
  }, []);

  useEffect(() => {
    if (
      message &&
      message.messageContent !== undefined &&
      message.messageContent !== null &&
      message.messageContent !== ""
    ) {
      Swal.fire({
        icon: message.messageType || "error",
        title:
          message.messageType === MessageTypes.success
            ? localizations?.MESSAGE_SUCCESS ?? "BAŞARILI!"
            : localizations?.MESSAGE_ERROR ?? "HATA!",
        text: message.messageContent,
        showCancelButton: false,
        confirmButtonText: localizations?.MESSAGE_GO_HOME_CONFIRM_BTN,
      }).then((result) => {
        removeErrorMsg(ALL_CLASSES);
        if (result.isConfirmed) {
          history.push("/");
        }
      });
    }
    // eslint-disable-next-line
  }, [message]);

  const columns = [
    { Header: localizations?.CLASS ?? "Class", accessor: "class" },
    {
      Header: localizations?.ACTIONS ?? "Actions",
      accessor: "preview",
      // eslint-disable-next-line react/prop-types
      Cell: ({ value: [data] }) => (
        <SuiBox mx={1} display="flex">
          <Tooltip title={localizations?.EDIT ?? "Düzenle"} placement="bottom">
            <IconButton
              aria-label={localizations?.EDIT}
              onClick={(e) => {
                e.preventDefault();
                history.push({
                  pathname: "/class/edit",
                  state: { classId: data.id },
                });
              }}
            >
              <Pencil size={32} weight="duotone" color="#7493b6" />
            </IconButton>
          </Tooltip>
        </SuiBox>
      ),
    },
  ];

  const getDataTableData = (dataList, filter, lang) => ({
    columns,
    rows:
      dataList && dataList.length > 0
        ? dataList
            .filter((c) => {
              let lowercaseFilter = "";
              if (filter && filter !== "") {
                lowercaseFilter = filter.toLocaleLowerCase(lang);
              }
              return (
                c.className.toLocaleLowerCase(lang).includes(lowercaseFilter) ||
                c.classLevel.toLocaleLowerCase(lang).includes(lowercaseFilter)
              );
            })
            .map((c) => ({
              class: c.className,
              preview: [{ id: c.id }],
            }))
        : [],
  });

  const memoizedTableData = useMemo(
    () => getDataTableData(classList, classFilter, language),
    [classFilter, classList, language]
  );
  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox py={3}>
          <Grid container>
            <Grid item sm={7} xs={12}>
              <h3>{localizations?.ALL_CLASSES ?? "Class Listesi"}</h3>
            </Grid>
            <Grid item sm={5} xs={12} sx={{ textAlign: "right" }}>
              <SuiInput
                size="small"
                type="search"
                placeholder={localizations?.CLASS_FILTER_INPUT_PLACEHOLDER ?? "Class Ara..."}
                icon={{ component: <FunnelSimple />, direction: "left" }}
                value={classFilter}
                onChange={(e) => setClassFilter(e.target.value)}
              />
            </Grid>
            <Grid item lg={12} xs={12} mt={3}>
              <SuiTypography variant="h6" fontWeight="medium">
                {localizations?.ALL_CLASSES ?? "Class Listesi"}
              </SuiTypography>

              <Formik
                initialValues={{
                  organization: null,
                  subOrganization: null,
                }}
                onSubmit={() => {}}
              >
                {(formikProps) => {
                  const { setFieldValue, values, errors, touched, setFieldTouched } = formikProps;
                  return (
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <CustomFormField
                          options={
                            allOrganizations &&
                            allOrganizations?.map((organization) => ({
                              value: organization.id,
                              label: organization.organizationKey,
                            }))
                          }
                          type="select"
                          placeholder="Kurum Seçiniz..."
                          value={values.organization}
                          setFieldValue={(field, value) => {
                            setFieldValue(field, value);
                            setFieldValue("subOrganization", null);
                            startScreen({});
                            if (value && value.value) {
                              listByOrganizationId({ organizationId: value.value });
                            }
                          }}
                          label={localizations?.ORGANIZATION ?? "ORGANIZATION"}
                          name="organization"
                          touched={touched}
                          errors={errors}
                          error={false}
                          success={false}
                          setFieldTouched={setFieldTouched}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <CustomFormField
                          disabled={!values.organization}
                          options={
                            allSubOrganizations &&
                            allSubOrganizations.map((subOrg) => ({
                              value: subOrg.id,
                              label: subOrg.subOrganizationKey,
                            }))
                          }
                          type="select"
                          placeholder="Şube Seçiniz..."
                          value={values.subOrganization}
                          label={localizations?.SUB_ORGANIZATION ?? "SUB ORGANIZATION"}
                          name="subOrganization"
                          touched={touched}
                          errors={errors}
                          setFieldTouched={setFieldTouched}
                          setFieldValue={(field, value) => {
                            setFieldValue(field, value);

                            if (
                              values.organization &&
                              values.organization.value &&
                              value &&
                              value.value
                            ) {
                              startScreen({
                                organizationId: values.organization.value,
                                subOrganizationId: value.value,
                              });
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                  );
                }}
              </Formik>
            </Grid>
            <Grid item lg={12} xs={12} mt={3}>
              <DataTable
                table={memoizedTableData}
                entriesPerPage={{ defaultValue: 5, entries: [5, 10, 25, 50] }}
                pagination={{ variant: "contained", color: "dark" }}
              />
            </Grid>
          </Grid>
        </SuiBox>
      </DashboardLayout>
    </>
  );
};

ClassList.defaultProps = {
  allSubOrganizations: [],
  classList: [],
  message: null,
  localizations: null,
  language: "TR",
  listByOrganizationId: () => {},
  allOrganizations: [],
  getAllOrganizations: () => {},
};

ClassList.propTypes = {
  allSubOrganizations: PropTypes.arrayOf(PropTypes.any),
  message: PropTypes.objectOf(PropTypes.any),
  localizations: PropTypes.objectOf(PropTypes.any),
  startScreen: PropTypes.func.isRequired,
  removeErrorMsg: PropTypes.func.isRequired,
  language: PropTypes.string,
  listByOrganizationId: PropTypes.func,
  allOrganizations: PropTypes.arrayOf(PropTypes.any),
  getAllOrganizations: PropTypes.func,
  classList: PropTypes.arrayOf(PropTypes.any),
};

const mapStateToProps = (state) => {
  const subOrganizations = Array.isArray(state?.data?.subOrganizations)
    ? state.data.subOrganizations
    : [];

  const organizations = Array.isArray(state?.data?.organizations) ? state.data.organizations : [];
  const classes = Array.isArray(state?.data?.classes) ? state.data.classes : [];
  return {
    allSubOrganizations: subOrganizations,
    allOrganizations: organizations,
    message: state.message[ALL_CLASSES],
    localizations: state.localization.pairs,
    language: state.localization.language ?? "TR",
    classList: classes,
  };
};

const mapDispatchToProps = {
  startScreen: startAllClassesScreen,
  removeErrorMsg: removeMessage,
  listByOrganizationId: getSubOrganizationListByOrganizationId,
  getAllOrganizations: startAllOrganizationsScreen,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClassList);
